import './forms.css'
import React from 'react'
import { renderField } from './_fieldRenderer'
import { FormGroup, Row, Col } from 'react-bootstrap'
import { Field, reduxForm, FieldArray } from 'redux-form'
import Button from 'elements/CustomButton/CustomButton.jsx'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'

class ItemForm extends React.Component {

    render () {
        const { handleSubmit, submitting } = this.props
        return (
            <form onSubmit={handleSubmit}>
                <Row>
                    <Col md={4}>
                        <FormGroup>
                            <Field
                                name='name'
                                type='text'
                                component={renderField}
                                label='Nome'
                                placeholder='Nome'
                            />
                        </FormGroup>
                    </Col>

                    <Col md={8}>
                        <FormGroup>
                            <Field
                                name='description'
                                type='text'
                                component={renderField}
                                label='Descrição'
                                placeholder='Descrição'
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <FieldArray name='fabricLines' component={this._renderLines} />
                </Row>

                <Row>
                    <FieldArray name='composition' component={this._renderComposition} />
                </Row>

                <Row>
                    <FieldArray name='accessories' component={this._renderAccessories} />
                </Row>

                <Row>
                    <Col md={6} sm={12} xs={12}>
                        <Button
                            style={{ width: '100%', marginTop: 10 }}
                            bsStyle='danger'
                            type='button'
                            disabled={submitting}
                            onClick={this._handleCancel}
                            wd
                        >
                            Cancelar
                         </Button>
                    </Col>
                    <Col md={6} sm={12} xs={12}>
                        <Button
                            style={{ width: '100%', marginTop: 10 }}
                            bsStyle='default'
                            type='submit'
                            disabled={submitting}
                            fill
                        >
                            Salvar
                         </Button>
                    </Col>
                </Row>
            </form >
        )
    }

    _handleCancel = () => {
        this.props.reset() //form reset - redux-form action creator
        this.props.handleCancel() //function passed via props
    }

    _renderLines ({ fields }) {
        return (
            <div>
                {fields.map((line, index) => {
                    let data = fields.get(index)
                    return (
                        <Col md={3} key={index}>
                            <FormGroup>
                                <Field
                                    optional
                                    name={data.id}
                                    type='text'
                                    component={renderField}
                                    label={data.name}
                                />
                            </FormGroup>
                        </Col>
                    )
                })}
            </div>
        )
    }

    _renderComposition = ({ fields, meta: { error } }) => (
        <div className='form_sub_block'>
            <div className='form_sub_actions'>
                <span className='form_sub_actions--header'>
                    Composê
            </span>
                {error && (
                    <span className='form_sub_actions--error'>
                        {error}
                    </span>
                )}
                <Button
                    bsStyle='default'
                    type='button'
                    className='form_sub_actions--button'
                    fill
                    onClick={() => fields.push({})}
                >
                    Adicionar
            </Button>
            </div>

            {fields.map((composition, index) => (
                <div className='form_sub_action--rendered-item' key={index}>
                    <Row>
                        <Col md={8} sm={12}>
                            <FormGroup>
                                <Field
                                    name={`${composition}.description`}
                                    type='text'
                                    component={renderField}
                                    label='Descrição'
                                />
                            </FormGroup>
                        </Col>

                        <Col md={4} sm={12}>
                            <FormGroup>
                                <Field
                                    name={`${composition}.percentage`}
                                    type='number'
                                    component={renderField}
                                    label='Proporção'
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <FontAwesomeIcon
                        className='form_sub_action--remove'
                        icon='trash'
                        onClick={() => fields.remove(index)}
                    />
                </div>
            ))}
        </div>
    )

    _renderAccessories = ({ fields, meta: { error } }) => (
        <div className='form_sub_block'>
            <div className='form_sub_actions'>
                <span className='form_sub_actions--header'>
                    Acessórios
            </span>
                <Button
                    bsStyle='default'
                    type='button'
                    className='form_sub_actions--button'
                    fill
                    onClick={() => fields.push({})}
                >
                    Adicionar
            </Button>
            </div>

            {fields.map((acessory, index) => (
                <div className='form_sub_action--rendered-item' key={index}>
                    <Row>
                        <Col md={8} sm={12}>
                            <FormGroup>
                                <Field
                                    name={`${acessory}.description`}
                                    type='text'
                                    component={renderField}
                                    label='Descrição'
                                />
                            </FormGroup>
                        </Col>

                        <Col md={4} sm={12}>
                            <FormGroup>
                                <Field
                                    name={`${acessory}.price`}
                                    type='number'
                                    component={renderField}
                                    label='Valor'
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <FontAwesomeIcon
                        className='form_sub_action--remove'
                        icon='trash'
                        onClick={() => fields.remove(index)}
                    />
                </div>
            ))}
        </div>
    )
}

const validate = values => {
    const errors = {}
    if (!values.name) { errors.name = 'Obrigatório' }
    if (!values.description) { errors.description = 'Obrigatório' }

    if (!values.composition || !values.composition.length) {
        errors.composition = { _error: 'Uma variante deve possuir pelo menos uma composição' }
    } else {
        const compositionErrorsArray = []
        values.composition.forEach((comp, compIndex) => {
            const compositionErrors = {}
            if (!comp || !comp.description) {
                compositionErrors.description = 'Obrigatório'
                compositionErrorsArray[compIndex] = compositionErrors
            }

            if (!comp || !comp.percentage) {
                compositionErrors.percentage = 'Obrigatório'
                compositionErrorsArray[compIndex] = compositionErrors
            }
        })

        if (compositionErrorsArray.length) {
            errors.composition = compositionErrorsArray
        }
    }

    return errors
}

ItemForm = reduxForm({ form: 'ItemForm', validate })(ItemForm)
export default ItemForm



// WEBPACK FOOTER //
// ./src/forms/ItemForm.jsx